import { render, staticRenderFns } from "./detailInsureInfo.vue?vue&type=template&id=2e30efba&scoped=true&"
import script from "./detailInsureInfo.vue?vue&type=script&lang=js&"
export * from "./detailInsureInfo.vue?vue&type=script&lang=js&"
import style0 from "./detailInsureInfo.vue?vue&type=style&index=0&id=2e30efba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e30efba",
  null
  
)

export default component.exports